import {StatusDetailRes, WorkflowStatusMinRes} from "../status.contract";
import {NoteDetailRes} from "../note/note.contract";
import {WorkflowDetailRes} from "../workflow.contract";
import {TrackerType} from '../../../../enums';
import {Type} from 'class-transformer';
import {
    ColumnType,
    yascDisplayName,
    FilterType,
    yascTableIgnore, yascTableIndex,
    yascFilterByFn,
    yascFilterConfig,
    YascOptionItem,
    yascOptionsKey,
    yascRequired,
    yascFormIgnore
} from '@yasc/yasc-material-components';
import {ProjectSummaryGroupingRes} from '../project.contract';
import {
    yascFormGrid, yascRequestOverride, yascTableColumn,
    yascTableDisplayFn, yascTableFilterType, yascTableLevelOfDetail
} from '@yasc/yasc-material-components';

export class TrackerDetailRes {
    // TODO: hide per default -> maybe map to table No.?
    @yascDisplayName('general_backendId')
    @yascFormIgnore()
    @yascTableIgnore(true)
    id!: number;

    @yascDisplayName('general_name')
    @yascTableIndex(1)
    @yascFormGrid({ row: 4, width: 1 })
    @yascRequired()
    name!: string;

    @yascTableIgnore(true)
    @yascFormIgnore()
    @yascDisplayName('general_internalName')
    internalName: string = '';

    @yascTableIgnore(true)
    @yascFormIgnore()
    @yascDisplayName('general_type')
    type!: TrackerType;

    isActive: boolean = true;
    requireTasks: boolean = false;
    requireEfforts: boolean = false;

    @yascDisplayName('general_currentStatus')
    @yascTableDisplayFn((value?: StatusDetailRes) => value?.name ?? '')
    @yascTableColumn(ColumnType.Select)
    @yascFormGrid({ row: 2, width: 2 })
    @yascRequestOverride('currentStatusId')
    @yascOptionsKey('availableWorkflows')
    @yascTableLevelOfDetail(2)
    @Type(() => StatusDetailRes)
    @yascTableFilterType(FilterType.select)
    @yascFilterByFn((value: TrackerDetailRes) => value.currentWorkflowStatus.id)
    @yascFilterConfig({
        getGroup: (value: ProjectSummaryGroupingRes) => value?.availableWorkflows ?? [],
        mapToFilter: (value: WorkflowStatusMinRes) => new YascOptionItem(value.name, value.id)
    })
    currentWorkflowStatus!: StatusDetailRes;

    workflowId!: number;

    @yascTableIgnore(true)
    @Type(() => StatusDetailRes)
    @yascFormIgnore()
    statusHistory: StatusDetailRes[] = [];

    @yascTableIgnore(true)
    @yascFormIgnore()
    @Type(() => NoteDetailRes)
    notes: NoteDetailRes[] = [];


    @yascTableIgnore(true)
    @yascFormIgnore()
    setStatusOptions!:() => YascOptionItem<number>
}


export abstract class MinTrackerRes {
    id!: number;

    @Type(() => WorkflowDetailRes)
    workflow!: WorkflowDetailRes;

    @Type(() => StatusDetailRes)
    currentStatus!: StatusDetailRes;
}

export class TrackerCreateReq {
    workflowId!: number;
    name!: string;
    title?: string | null;
    internalName?: string | null;
    type!: TrackerType;
    currentStatusId!: number;
    color?: string | null;
    source?: string | null;
}

export class TrackerAdvanceReq {
    trackerId!: number
    statusId!: number
}

export class TrackerWorkflowRes{
    id!:number;
    currentWorkflowStatus!: StatusDetailRes;
    name!:string;
}